module.exports = "/_next/static/images/ec32ffe23968b920feb319228dbf9e4d-roxinho-scene-card-with-phone-lg@2x.jpg";